/* THIS FILE IS AUTO-GENERATED! DO NOT MODIFY!! */
/* eslint-disable */
// @ts-nocheck

import type * as Types from '@/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { TeamsForSidebarFragmentDoc, TeamForSidebarFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TeamsForSidebarQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TeamsForSidebarQuery = { __typename?: 'QueryPrediction', teams: Array<{ __typename?: 'TeamType', id: string, name: string, default: boolean, icon: string | null | undefined, created: any } | null | undefined> | null | undefined };

export type TeamForSidebarQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type TeamForSidebarQuery = { __typename?: 'QueryPrediction', team: { __typename?: 'TeamType', id: string, name: string, icon: string | null | undefined, oraclesCount: number | null | undefined, chainsCount: number | null | undefined, modelsApisCount: number | null | undefined, trainingProjectsCount: number | null | undefined } | null | undefined };


export const TeamsForSidebarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamsForSidebar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamsForSidebarFragment"}}]}}]}},...TeamsForSidebarFragmentDoc.definitions]} as unknown as DocumentNode<TeamsForSidebarQuery, TeamsForSidebarQueryVariables>;
export const TeamForSidebarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamForSidebar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamForSidebarFragment"}}]}}]}},...TeamForSidebarFragmentDoc.definitions]} as unknown as DocumentNode<TeamForSidebarQuery, TeamForSidebarQueryVariables>;
export const namedOperations = {
  Query: {
    TeamsForSidebar: 'TeamsForSidebar',
    TeamForSidebar: 'TeamForSidebar'
  }
}

/**
 * __useTeamsForSidebarQuery__
 *
 * To run a query within a React component, call `useTeamsForSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsForSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsForSidebarQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamsForSidebarQuery(baseOptions?: Apollo.QueryHookOptions<TeamsForSidebarQuery, TeamsForSidebarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsForSidebarQuery, TeamsForSidebarQueryVariables>(TeamsForSidebarDocument, options);
      }
export function useTeamsForSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsForSidebarQuery, TeamsForSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsForSidebarQuery, TeamsForSidebarQueryVariables>(TeamsForSidebarDocument, options);
        }
export type TeamsForSidebarQueryHookResult = ReturnType<typeof useTeamsForSidebarQuery>;
export type TeamsForSidebarLazyQueryHookResult = ReturnType<typeof useTeamsForSidebarLazyQuery>;
export type TeamsForSidebarQueryResult = Apollo.QueryResult<TeamsForSidebarQuery, TeamsForSidebarQueryVariables>;
export function refetchTeamsForSidebarQuery(variables?: TeamsForSidebarQueryVariables) {
      return { query: TeamsForSidebarDocument, variables: variables }
    }
/**
 * __useTeamForSidebarQuery__
 *
 * To run a query within a React component, call `useTeamForSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamForSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamForSidebarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamForSidebarQuery(baseOptions: Apollo.QueryHookOptions<TeamForSidebarQuery, TeamForSidebarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamForSidebarQuery, TeamForSidebarQueryVariables>(TeamForSidebarDocument, options);
      }
export function useTeamForSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamForSidebarQuery, TeamForSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamForSidebarQuery, TeamForSidebarQueryVariables>(TeamForSidebarDocument, options);
        }
export type TeamForSidebarQueryHookResult = ReturnType<typeof useTeamForSidebarQuery>;
export type TeamForSidebarLazyQueryHookResult = ReturnType<typeof useTeamForSidebarLazyQuery>;
export type TeamForSidebarQueryResult = Apollo.QueryResult<TeamForSidebarQuery, TeamForSidebarQueryVariables>;
export function refetchTeamForSidebarQuery(variables: TeamForSidebarQueryVariables) {
      return { query: TeamForSidebarDocument, variables: variables }
    }